import {
  SET_KB_DETAILS,
  SET_KB_SEARCH_RESULTS,
  SET_KB_UI_FLAGS,
  SET_SELECTED_ARTICLE_DATA
} from '../types';
import KBApi from 'widget/api/kb';
import { sendExceptionToSentry } from 'shared/helpers/sentry';

const state = {
  kbDetails: {
    origin: '',
    pinnedArticles: []
  },
  uiFlags: {
    isFetchingResults: false
  },
  searchResults: [],
  selectedArticleDetails: {}
};

export const getters = {
  getKbDetails: $state => $state.kbDetails,
  getSearchResults: $state => $state.searchResults,
  getUiFlags: $state => $state.uiFlags,
  getSelectedArticleDetails: $state => $state.selectedArticleDetails
};

export const actions = {
  fetchKbDetails: async ({ commit }, websiteToken) => {
    commit(SET_KB_UI_FLAGS, { isFetchingResults: true });
    try {
      const { data } = await KBApi.getKbDetails(websiteToken);
      const { origin, pinned_articles: pinnedArticles } = data || {};
      commit(SET_KB_DETAILS, { origin, pinnedArticles});
    } catch (error) {
      sendExceptionToSentry(error);
    } finally {
      commit(SET_KB_UI_FLAGS, { isFetchingResults: false });
    }
  },
  searchKbArticles: async ({ commit }, request_data) => {
    commit(SET_KB_UI_FLAGS, { isFetchingResults: true });
    try {
      const { websiteToken, query } = request_data;
      const { data } = await KBApi.searchKbArticles(websiteToken, query);
      commit(SET_KB_SEARCH_RESULTS, data?.articles);
    } catch (error) {
      sendExceptionToSentry(error);
    } finally {
      commit(SET_KB_UI_FLAGS, { isFetchingResults: false });
    }
  },
  clearSearchResults: async ({ commit }) => {
    commit(SET_KB_SEARCH_RESULTS, []);
  },
  fetchArticleDetails: async ({ commit }, request_data) => {
    commit(SET_KB_UI_FLAGS, { isFetchingResults: true });
    try {
      const { websiteToken, articleId } = request_data;
      const { data } = await KBApi.getArticleDetails(websiteToken, articleId);
      commit(SET_SELECTED_ARTICLE_DATA, data?.data);
    } catch (error) {
      sendExceptionToSentry(error);
    } finally {
      commit(SET_KB_UI_FLAGS, { isFetchingResults: false });
    }
  }
};

export const mutations = {
  [SET_KB_DETAILS]($state, data) {
    $state.kbDetails = data;
  },
  [SET_KB_SEARCH_RESULTS]($state, data) {
    $state.searchResults = data;
  },
  [SET_KB_UI_FLAGS]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [SET_SELECTED_ARTICLE_DATA]($state, data) {
    $state.selectedArticleDetails = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
